BryanAnthonys = window.BryanAnthonys || {};
BryanAnthonys.trackOrder = function (order, trackingKey) {
    const trackingOrderUrl = 'https://baservices.bryananthonys.com/track-order-shipment';
    const config = BryanAnthonys.makePostConfig('json');
    config.body = JSON.stringify({order, trackingKey});

    return new Promise(function (resolve, reject) {
        fetch(trackingOrderUrl, config)
            .then(BryanAnthonys.decodeJsonResponse)
            .then(response => resolve(response.data))
            .catch(reject);
    });
};
BryanAnthonys.base64DecodeUrl = function (str) {
    str = (str + '===').slice(0, str.length + (str.length % 4));

    return str.replace(/-/g, '+').replace(/_/g, '/');
};

customElements.define('order-tracking-form', class extends HTMLElement {
    connectedCallback() {
        this.addEventListener('submit', event => {
            event.preventDefault();
            const formData = new FormData(event.target);
            this.submitButton.classList.add('loading');

            BryanAnthonys.trackOrder(formData.get('order_number'), formData.get('order_email'))
                .then(response => {
                    if (!response.shipped && response.fulfillment_status === null) {
                        return this.showError(BryanAnthonys.strings.orderTracking.notShipped);
                    }

                    if (!response.shipped) {
                        return this.showError(BryanAnthonys.strings.orderTracking.noTracking);
                    }

                    this.closest('order-tracking-component').renderTrackingDetails(formData.get('order_number'), response);
                })
                .catch(error => {
                    if (error instanceof ResponseException) {
                        error.resolveResponse().then(response => {
                            try {
                                this.showError(JSON.parse(response).message);
                            } catch (e) {
                                console.error(e);

                                this.showError(BryanAnthonys.strings.general.genericAjaxError);
                            }
                        });
                    } else {
                        this.showError(BryanAnthonys.strings.general.genericAjaxError);
                    }
                })
                .finally(() => this.submitButton.classList.remove('loading'));
        });
    }

    get submitButton() {
        return this.querySelector('button[type="submit"]');
    }

    showError(message) {
        this.querySelectorAll('[data-status-banner]').forEach(banner => banner.remove());

        this.querySelector('form').appendChild(
            this.closest('order-tracking-component').makeErrorBanner(message)
        );

        return null;
    }
});

customElements.define('order-tracking-component', class extends HTMLElement {
    connectedCallback() {
        document.addEventListener('DOMContentLoaded', () => this.applyUrlTrackingParams());
    }

    renderTrackingDetails(order, response) {
        this.form.classList.add('hidden');
        this.trackingShipments.innerHTML = '';
        this.trackingDetails.classList.remove('hidden');

        if (!response.shipped && response.fulfillment_status === null) {
            this.appendChild(this.makeErrorBanner(BryanAnthonys.strings.orderTracking.notShipped));

            return;
        }

        if (!response.shipped) {
            this.appendChild(this.makeErrorBanner(BryanAnthonys.strings.orderTracking.noTracking));

            return;
        }

        this.insertAdjacentHTML(
            'afterbegin',
            '<h2 class="center light-weight mb-4 h4 h3-desktop">Order <span data-order-name></span></h2>'
        );
        this.querySelector('[data-order-name]').innerText = `${response.order_name} from ${response.created_at}`;

        response.fulfillments.forEach((fulfillment, index) => {
            const key = `fulfillment-${index}-${order}`;
            BryanAnthonys.unsafeDataBag[key] = fulfillment;
            const shipmentTracking = document.createElement('order-shipment-tracking');
            shipmentTracking.dataset.key = key;
            shipmentTracking.dataset.number = index + 1;
            this.appendChild(shipmentTracking);
        });
    }

    applyUrlTrackingParams() {
        const pageUrl = new URL(window.location.href);
        const trackingParams = pageUrl.searchParams.get('tracking_params');
        if (!trackingParams) {
            return;
        }

        const [order, trackingKey] = atob(BryanAnthonys.base64DecodeUrl(trackingParams)).split('-|||-');

        this.classList.add('loading');
        BryanAnthonys.trackOrder(order, trackingKey)
            .then(response => this.renderTrackingDetails(order, response))
            .catch(e => console.error(e))
            .finally(() => this.classList.remove('loading'));
    }

    makeErrorBanner(message) {
        const banner = document.createElement('div');
        banner.classList.add('status-banner', 'status-banner--error', 'mt-3');
        banner.innerText = message;
        banner.setAttribute('data-status-banner', '');

        return banner;
    }

    get form() {
        return this.querySelector('order-tracking-form');
    }

    get trackingDetails() {
        return this.querySelector('[data-tracking-details]');
    }

    get trackingShipments() {
        return this.querySelector('[data-tracking-shipments]');
    }
});

customElements.define('order-shipment-tracking', class extends HTMLElement {
    connectedCallback() {
        this.data = BryanAnthonys.unsafeDataBag[this.dataset.key];

        this.render();
    }

    render() {
        this.classList.add('order-shipment-tracking', 'mx-auto', 'w-100', 'p-3', 'border', 'mb-3');

        this.innerHTML = `
            <div class="block h4 w-100 mb-3 pb-3 border-bottom" data-heading>
                <span data-heading-shipment-company></span> shipment <a data-heading-shipment-number href="#"></a>
                from <span data-heading-shipment-date></span>
            </div>
            <div data-current-status></div>
            <details class="order-shipment-tracking__shipment-items details-disclosure w-100 w-50-desktop pr-4-desktop mb-5" open>
                <summary class="cursor-pointer order-shipment-tracking__shipment-items-summary mb-3 bold">
                    In this shipment
                    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 46 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M45 1L22.9127 25L1 0.999998" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </summary> 
                <div data-shipment-contents></div>
            </details>
            <div data-shipment-events class="shipment-events-wrapper w-100 w-50-desktop mb-3 pr-1"></div>
        `;

        this.querySelector('[data-heading-shipment-company]').innerText = this.data.tracking_company;
        this.querySelector('[data-heading-shipment-date]').innerText = this.data.created_at;
        const shipmentNumber = this.querySelector('[data-heading-shipment-number]');
        shipmentNumber.innerText = this.data.tracking_number || `#${this.dataset.number}`;
        if (this.data.tracking_url) {
            shipmentNumber.href = this.data.tracking_url;
            shipmentNumber.setAttribute('target', 'blank');
            shipmentNumber.setAttribute('title', 'Shipment details on carrier website');
            shipmentNumber.setAttribute('aria-label', 'Shipment details on carrier website');
        }


        this.renderShipmentContents();
        this.renderEvents();
        this.renderCurrentStatus();
    }

    renderShipmentContents() {
        const contents = this.shipmentContents;
        this.data.line_items.forEach(lineItem => {
            const lineDataAttr = `data-line="${parseInt(lineItem.id)}"`;

            contents.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(`
                <div class="order-shipment-tracking__shipment-item mb-3" ${lineDataAttr}>
                    <img 
                        src="https://cdn.shopify.com/s/files/1/1726/4473/files/ba-logo-load-mobile-1500.jpg?v=1689291820" 
                        class="responsive-image order-shipment-tracking__shipment-item-image"
                        width="50" height="50" loading="lazy" alt="Product image"
                    />
                    <div data-name class="order-shipment-tracking__shipment-item-name pr-3"></div>
                    <div class="order-shipment-tracking__shipment-item-qty">x ${parseInt(lineItem.quantity)}</div>
                </div>
            `));

            contents.querySelector(`[${lineDataAttr}] [data-name]`).innerText = lineItem.name;

            const image = contents.querySelector(`[${lineDataAttr}] img`);
            image.alt = lineItem.name;
            if (lineItem.image) {
                image.src = BryanAnthonys.resizeImage(lineItem.image, 150, 150, 'center');
            }
        });
    }

    renderEvents() {
        for (const dateEvents of this.data.events) {
            const date = dateEvents[0].happened_at_date;
            const dateHandle = BryanAnthonys.handleize(date);

            const eventsTemplates = dateEvents.map(dateEvent => {
                const eventKey = parseInt(dateEvent.happened_at_timestamp) + dateEvent.message + dateEvent.status;

                return `
                    <div class="shipment-events__event mb-3 hidden" data-event-key=${JSON.stringify(eventKey)}>
                        <div class="shipment-events__event-time bold" data-event-time></div>
                        <div class="shipment-events__event-message size-13" data-event-message></div>
                        <div class="shipment-events__event-city size-13 pt-1 flex align-items-center">
                            <svg
                              class="icon icon-map_pin" aria-hidden="true" focusable="false" 
                              viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
                            >
                              <path 
                                  d="M10 17.3662C10 6.15304 17.2209 2 24.5 2C31.7791 2 39 6.15304 39 17.3662C39 28.5794 24.5 47 24.5 47C24.5 47 10 28.5321 10 17.3662Z" 
                                  stroke="#231F20" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"
                              />
                              <path 
                                d="M32 15C32 18.8097 28.7001 22 24.5 22C20.2999 22 17 18.8097 17 15C17 11.1903 20.2999 8 24.5 8C28.7001 8 32 11.1903 32 15Z" 
                                stroke="currentColor" stroke-width="2"
                              />
                            </svg>
                            <span data-event-city></span>
                        </div>
                    </div>
                `;
            });

            this.shipmentEvents.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(`
                <div class="shipment-events mb-3" data-date=${JSON.stringify(dateHandle)}>
                    <div class="shipment-events__date status-banner mb-3 pt-1 pb-1" data-shipment-events-date></div>
                    <div class="shipment-events__list">
                        ${eventsTemplates.join('')}
                    </div>
                <div>
            `));

            const shipmentEventContainer = this.querySelector(`[data-date=${JSON.stringify(dateHandle)}]`);
            shipmentEventContainer.querySelector('[data-shipment-events-date]').innerText = date;

            dateEvents.forEach(dateEvent => {
                const eventKey = parseInt(dateEvent.happened_at_timestamp) + dateEvent.message + dateEvent.status;
                const eventContainer = shipmentEventContainer.querySelector(
                    `[data-event-key=${JSON.stringify(eventKey)}]`
                );
                eventContainer.querySelector('[data-event-time]').innerText = dateEvent.happened_at_time;
                if (dateEvent.city && dateEvent.city.trim()) {
                    eventContainer.querySelector('[data-event-city]').innerText = dateEvent.city;
                } else {
                    eventContainer.querySelector('[data-event-city]').parentElement.classList.add('hidden');
                }
                eventContainer.querySelector('[data-event-message]').innerText = dateEvent.message
                    ? dateEvent.message
                    : dateEvent.status.replaceAll('_', ' ').toUpperCase();

                eventContainer.classList.remove('hidden');
            });
        }
    }

    renderCurrentStatus() {
        if (!this.data.events || !this.data.events.length) {
            return;
        }

        const lastEvent = this.data.events[0][0];
        if (!lastEvent) {
            return;
        }

        const currentStatus = this.currentStatus;

        currentStatus.className = 'status-banner mb-4 w-100';
        currentStatus.innerText = lastEvent.status.replaceAll('_', ' ').toUpperCase()
            + ' - ' + (lastEvent.city || '') + ' - ' + lastEvent.happened_at_date + ' ' + lastEvent.happened_at_time;

        if (['out_for_delivery', 'delivered'].includes(lastEvent.status.toLowerCase())) {
            currentStatus.classList.add('status-banner--success');
        }

        if (['attempted_delivery', 'failure'].includes(lastEvent.status.toLowerCase())) {
            currentStatus.classList.add('status-banner--error');
        }

        if (this.data.tracking_url && ['out_for_delivery', 'delivered', 'attempted_delivery', 'failure'].includes(lastEvent.status.toLowerCase())) {
            const link = document.createElement('a');
            link.setAttribute('target', 'blank');
            link.setAttribute('title', 'Shipment details on carrier website');
            link.setAttribute('aria-label', 'Shipment details on carrier website');
            link.href = this.data.tracking_url;
            link.classList.add('ml-1');
            link.innerText = 'More details';
            currentStatus.innerText = currentStatus.innerText + ' - ';
            currentStatus.appendChild(link);
        }
    }

    get shipmentContents() {
        return this.querySelector('[data-shipment-contents]');
    }

    get shipmentEvents() {
        return this.querySelector('[data-shipment-events]');
    }

    get currentStatus() {
        return this.querySelector('[data-current-status]');
    }

    get heading() {
        return this.querySelector('[data-heading]');
    }
});